import axios from "axios";
import { API_URL } from "../config";

export const getCountries = async () => {
  const res = await axios.get(`${API_URL}/countries/`);
  return res.data;
};


export const updateCountry = async (countryId) => {
 const tokenString = localStorage.getItem("authToken");
 const token = JSON.parse(tokenString);

  const res = await axios.post(
    `${API_URL}/student/update-location/`,
    { country_id: countryId },
    {
      headers: {
        Authorization: `Bearer ${token.access}`,
      },
    }
  );

  return res.data;
};
